import type { ComputedRef, InjectionKey, Ref } from "vue";

export interface RegisteredEntry {
    name: string;
    visible: ComputedRef<boolean>;
}

export interface RegisteredSection {
    id: string;
    title: string;
    total: ComputedRef<number>;
    visible: ComputedRef<number>;
}

export const designSystemQueryKey: InjectionKey<Ref<string>> = Symbol("designSystemQuery");
export const designSystemSectionKey: InjectionKey<(entry: RegisteredEntry) => void> = Symbol("designSystemSection");
export const designSystemPageKey: InjectionKey<(section: RegisteredSection) => void> = Symbol("designSystemPage");

export const matchesQuery = (query: string, ...haystack: (string | undefined)[]): boolean => {
    const needle = query.trim().toLowerCase();
    if (!needle) {
        return true;
    }
    return haystack.some((value) => value?.toLowerCase().includes(needle));
};

export const toAnchorId = (name: string): string =>
    `ds-${name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-|-$/g, "")}`;
